<template>
    <div class="to-top">
        <div  class="fix">
            <a href="//my.pcauto.com.cn/action/report/report.jsp" target="_blank" class="yjfk"></a>
            <a href="//www1.pcauto.com.cn/zt/footprint/index.html" target="_blank" class="lishi"></a>
            <a href="javascript:;" @click="toTop" class="toTop" v-show="isShowToTop"></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ToTop',
        data() {
            return {
                isShowToTop: false, //是否显示回到顶部
            }
        }, 
        methods: {
            //滚动
            scroll() {
                let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
                if(scrollTop > 300) {
                    this.isShowToTop = true
                }else {
                    this.isShowToTop = false
                }
            },
            //滚动到顶部
            toTop() {
                let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
                const timeToTop = setInterval( () => {
                  document.body.scrollTop = document.documentElement.scrollTop = scrollTop -= 40;
                  if(scrollTop <= 0) {
                     clearInterval(timeToTop)
                  }
                },10)
            }
        },  
        mounted() {
            window.addEventListener('scroll', this.scroll)
        }
    }
</script>

<style lang="scss" scoped>
.to-top {
    position: fixed;
    width: 50px;
    left: 50%;
    bottom: 5px;
    margin-left: 510px;
    z-index: 999;
    .fix {
        .yjfk {
            display: block;
            width: 50px;
            height: 50px;
            background: url($imageURL) no-repeat;
            background-position:  -0 -97px;
            &:hover {
                background-position: -50px -97px;
            }
        }
        .lishi {
            display: block;
            width: 50px;
            height: 50px;
            background: url(//www1.pcauto.com.cn/20160901/lishijilu/coinsbg.jpg) no-repeat 0px 0px;
            margin-top: 5px;
            &:hover {
                background-position: -60px 0px;
            }
        }
        .toTop {    
            display: block;
            width: 50px;
            height: 50px;
            margin-top: 5px;
            background: url($imageURL) no-repeat;
            background-position:  -0 -147px;
            &:hover {
               background-position: -50px -147px;
            }
        }
    }
}
</style>